import React from 'react'
import PropTypes from 'prop-types'
// import { Icon } from 'components/icons'
import { BackButton } from './backButton'
import { localized } from 'decorators'
// import { LoadingIndicator } from 'components/loading'
import { useStyles } from './pageTitle.css'

const PageTitle = ({ metadata, title, loading, ...props }) => {
  const classes = useStyles()

  const renderButtons = () => {
    if (!!props.buttons) {
      return <div className={classes.buttons}>{props.buttons}</div>
    }
    return null
  }

  return (
    <h4 className={`${classes.root} ${props.hideGoBack === true ? 'no-go-back' : 'can-go-back'}`}>
      <BackButton {...props} metadata={metadata} />
      {/* {loading && <span className={classes.loading}><LoadingIndicator size={16} /></span>} */}
      {/* <Icon className={classes.pageIcon} name={metadata.icon} /> */}
      <span className='title'>{title}</span>
      {renderButtons()}
    </h4>
  )
}

PageTitle.propTypes = {
  hideGoBack: PropTypes.bool,
  icon: PropTypes.string,
  title: PropTypes.string,
  backUrl: PropTypes.string,
  loading: PropTypes.bool,
  buttons: PropTypes.node
}
PageTitle.defaultProps = {
  hideGoBack: false,
  loading: false
}

export default localized(PageTitle)
